import {
  AudioVideoObserver,
  AudioVideoFacade,
  Logger
} from "amazon-chime-sdk-js";

export class VueAudioVideoObserver implements AudioVideoObserver {
  constructor(
    private vm: Vue,
    private audioVideo: AudioVideoFacade,
    private logger: Logger
  ) {}

  audioVideoDidStart(): void {
    this.logger.info("Video has started");
  }
}

export const AudioVideoKey = Symbol();
export const MeetingSessionKey = Symbol();
